import { Link, useNavigate } from 'react-router-dom';
import { appConfig } from '@/lib/config';
import { useAuthStore } from '@/stores/auth.store';
import { useLogoutMutation } from '@/hooks/useAuth';
import { Avatar, Button } from '@/components/ui';

export function Header() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const user = useAuthStore((s) => s.user);
  const logout = useLogoutMutation();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 glass border-b border-white/10 rounded-none">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-14 sm:h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 sm:gap-3 group min-w-0">
          <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-xl bg-brand-600 flex items-center justify-center shadow-glow group-hover:scale-105 transition-transform shrink-0">
            <span className="text-white font-bold text-xs sm:text-sm">MR</span>
          </div>
          <div className="min-w-0">
            <span className="font-bold text-base sm:text-lg">{appConfig.name}</span>
            <span className="hidden md:inline text-surface-500 text-sm ml-2">{appConfig.tagline}</span>
          </div>
        </Link>

        <nav className="flex items-center gap-1 sm:gap-2 shrink-0" aria-label="Main navigation">
          {isAuthenticated ? (
            <>
              <Link to="/rooms" className="btn-ghost text-xs sm:text-sm hidden xs:inline-flex">
                Rooms
              </Link>
              <Link to="/join" className="btn-ghost text-xs sm:text-sm hidden sm:inline-flex">
                Join
              </Link>
              <button
                type="button"
                onClick={() => navigate('/settings')}
                className="flex items-center gap-2 btn-ghost py-1.5 px-2 sm:px-3"
              >
                <Avatar src={user?.avatarUrl} name={user?.displayName ?? 'U'} size="sm" />
                <span className="hidden sm:inline text-sm truncate max-w-[100px]">{user?.displayName}</span>
              </button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => logout.mutate()}
                isLoading={logout.isPending}
                className="hidden md:inline-flex"
              >
                Sign Out
              </Button>
            </>
          ) : (
            <>
              <Link to="/guest" className="btn-ghost text-xs sm:text-sm">
                Guest
              </Link>
              <Link to="/login" className="btn-ghost text-xs sm:text-sm">
                Sign In
              </Link>
              <Link to="/register">
                <Button size="sm" className="text-xs sm:text-sm py-2 px-3 sm:px-4">
                  Sign Up
                </Button>
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
